import { IToken } from './auth/types';

function setToken(token: IToken) {
  try {
    localStorage.setItem('vendor-auth', JSON.stringify(token));
  } catch (e) {
    console.error('Error storing token', e);
  }
}

function getToken(): IToken | null {
  try {
    const storedToken = localStorage.getItem('vendor-auth');
    return storedToken ? (JSON.parse(storedToken) as IToken) : null;
  } catch (e) {
    console.error('Error retrieving token', e);
    return null;
  }
}

function clearToken() {
  localStorage.removeItem('vendor-auth');
}

const TokenService = {
  setToken,
  getToken,
  clearToken,
};

export default TokenService;
